import { useRef, useState } from 'react';
import classes from './SignupForm.module.css';
import qs from 'qs';
import { getAirData } from '../helpers/Options';
import PasswordForm from './PasswordForm';
import { useQueryClient, useMutation } from '@tanstack/react-query';

function SignupForm( props ) {
	const inputQty = useRef();
	const inputFirstName = useRef();
    const inputLastName = useRef();
	const inputPassword = useRef();
	const inputEmail = useRef();
	const inputEmailConfirmation = useRef();
	const [message, setMessage] = useState('');
	const [svcHours, setSvcHours] = useState("🟩");
	const [showSaving, setSaving] = useState(false);
	const [passwordFormIsShown, showPasswordForm] = useState(false);
	const [submitClass, setSubmitClass] = useState(classes.active);
	const thePoster = (typeof props.poster === 'undefined') ? null : props.poster[0];
	const theText = (typeof props.poster === 'undefined') ? null : props.text[0];
	const theClass = (props.active) ? classes.signupContainer : classes.signupContainerClose;
	const theStart = (props.signupQty>1) ? 0 : 1;
	const theValue = props.signupQty / 10;
	const theFunction = (props.signupQty > 0) ? 'changeSignup' : 'addSignup';
	const [signedIn, setSignIn] = useState(props.signedIn);

	const queryClient = useQueryClient();
	const userSignups = queryClient.getQueryData(['signups', props.email]);
	const updateSignups = useMutation({
		mutationFn: (saveData) => getAirData(qs.stringify(saveData)),
		onSuccess: (data, saveData) => {
			setMessage(data);
			setSaving(false);
			return queryClient.invalidateQueries({ queryKey: ['signups', props.email] });
		}
	});

	let showDevSignedIn = false;
	let theOptions = [];
	for (var i = theStart; i <= props.limit; i++) {theOptions.push(<option key={i} value={i}>{i*10+" total cards"}</option>);}


	function changeData(id, qty) {
		const changeArgs = { action: 'SAS_handleAJAX', function: 'changeSignup', recordID: id, quantity: qty };
		updateSignups.mutate(changeArgs);
	}
	function changeSignup(theQty) {
		const filteredSignups 	= userSignups.filter((signup) => signup.fields.Parent[0] === props.id);
		let delList 			= '';
		let totalReviewed = 0;

		filteredSignups.forEach((signup, idx) => {
			totalReviewed += signup.fields.Quantity;
			if (totalReviewed > theQty) {
				const numToDelete = totalReviewed - theQty;
				if (numToDelete >= signup.fields.Quantity) { delList += 'records[]=' + signup.id + '&'; }
				else { changeData(signup.id, numToDelete ); }
			}
		});
		const theBalance = theQty - totalReviewed;
		if (theBalance>0) { changeData(filteredSignups[0].id, theBalance+filteredSignups[0].fields.Quantity );}
		if (delList !== '') {
			const delData = { action: 'SAS_handleAJAX', function: 'deleteSignups', records: delList };
			updateSignups.mutate(delData);
		}
	}

	function checkStatus() {
		var theMessage='';
		theMessage += logMessage(inputFirstName?.current?.value, 'first name');
		theMessage += logMessage(inputLastName?.current?.value, 'last name');
		theMessage += logMessage(inputEmail?.current?.value, 'email address');
		theMessage += logMessage(inputEmailConfirmation?.current?.value, 'email address confirmation');
		setMessage(theMessage);
	}

	function submitHandler(event) {
		setSaving(true);
		event.preventDefault();
		checkStatus();
		if (submitClass === classes.active) {
			var thePassword 		= 'NONE';
			var saveUserFlag 		= 'false';
			const theEmail 			= inputEmail.current.value;
			const theLastName 		= inputLastName.current.value;
			const theFirstName 		= inputFirstName.current.value;
			const theQty 			= parseInt(inputQty.current.value);
			const svcHourFlag 		= (svcHours === '🟩') ? "no" : "yes";
			console.log(theFunction);
			if (theFunction === 'changeSignup') { changeSignup(theQty); return; }
		
			if (typeof inputPassword.current !== 'undefined') { thePassword = inputPassword.current.value; saveUserFlag = 'true'; }
			var data = {
				action: 	'SAS_handleAJAX',
				function: 	theFunction,
				'createUser': saveUserFlag,
				'password':	thePassword,
				'activity':	props.id,
				'actName':	props.title,
				'deadline':	props.deadline,
				'recordID':	props.signupID,
				'fname':	theFirstName,
				'lname':	theLastName,
				'email':	theEmail,
				'svcHours':	svcHourFlag,
				'quantity':	theQty
			};
			console.log(data);
			updateSignups.mutate(data);
		}
    }

	function setPassword() { showPasswordForm(true); allowSubmit(false) }
	function abortPW() {showPasswordForm(false);}
	function setSvcFlag() {
		if (svcHours === '🟩') { setSvcHours('✅') }
		else { setSvcHours('🟩') }
	}

	function allowSubmit(flag) {
		if (flag) { setSubmitClass(classes.active); }
		else {setSubmitClass(classes.inactive); }
	}

	function logMessage(ref, text) {
		if (typeof ref === 'undefined' || ref.length===0) { const theMessage = 'Please enter your '+text+'. '; return theMessage; }
		else { return ''; }
	}
	if (window.location.host.slice(0, 5)==="local") { showDevSignedIn=true; }
	function changeSignin() { setSignIn(!signedIn); }

	return(
		<div className={theClass}>
			<div className={classes.title}>
				<div>Signing up for {props.title}
					{showDevSignedIn && <span onClick={changeSignin}> {!signedIn && "Not "}Signedin</span>}
				</div>
				<div onClick={props.closeForm} className={classes.closeBtn}>❌</div>
			</div>
			<div className={classes.signupForm} >
				{showSaving && <div className={classes.sfOverly}></div>}
				<label htmlFor="firstname" className={classes.nameLabel}>Name:</label>
				<input id="firstname" type="text" defaultValue={props.firstname} ref={inputFirstName} className={classes.nameInput} />
				<input id="lastname" type="text" defaultValue={props.lastname} ref={inputLastName} className={classes.nameInput} />
				<label htmlFor="email" className={classes.emailLabel}>Email:</label>
				<input id="email" type="email" defaultValue={props.email} ref={inputEmail} className={classes.email} />
				<label htmlFor="emailConfirmation" className={classes.emailLabel}>Confirm Email:</label>
				<input id="emailConfirmation" type="email" defaultValue={props.email} ref={inputEmailConfirmation} className={classes.email} />
				<label className={classes.nameLabel}>Quantity:</label>
				<select id={props.id} ref={inputQty} defaultValue={theValue} className={classes.cardSelect}>{theOptions}</select>
				<div onClick={setSvcFlag} className={classes.serviceLabel}>{svcHours} I'd like service hours</div>
				<div className={classes.message}>{message}</div>
				
				{!passwordFormIsShown && !signedIn &&
					<button className={classes.saveInfo} onClick={setPassword}>Save my information for next time.</button>
				}
				{passwordFormIsShown &&
					<PasswordForm key={"pwForm"} pwRef={inputPassword} allowSubmit={allowSubmit} abort={abortPW} />
				}
				<button className={submitClass} type="submit" onClick={submitHandler}>Submit</button>
			</div>
			<div>{theText}</div>
			<div className={classes.suggest}>See <a href={thePoster} rel="noreferrer" target={"_blank"}>
				 other card making suggestions.</a>
			</div>
		</div>
	)
}

export default SignupForm;